<div class="pnl-discounts">
  <header>
      <h1>Descontos e promoções</h1>
  </header>
  <section>
    <div>
      <a [routerLink]="['cupons']">
        <figure>
          <fa-icon [icon]="faTicketAlt"></fa-icon>
        </figure>
        <span>
          <strong>Cupons de descontos</strong>
          <small>Crie cupons de descontos para os seus clientes</small>
        </span>
      </a>
      <a [routerLink]="['promocoes']">
        <figure>
          <fa-icon [icon]="faTags"></fa-icon>
        </figure>
        <span>
          <strong>Promoções</strong>
          <small>Crie promoções para os seus clientes</small>
        </span>
      </a>
    </div>
  </section>
</div>
